import { render, staticRenderFns } from "./FormularioProveedores.vue?vue&type=template&id=77846f52&scoped=true"
import script from "./FormularioProveedores.vue?vue&type=script&lang=js"
export * from "./FormularioProveedores.vue?vue&type=script&lang=js"
import style0 from "./FormularioProveedores.vue?vue&type=style&index=0&id=77846f52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77846f52",
  null
  
)

export default component.exports